// extracted by mini-css-extract-plugin
export default {"container":"registered-model-cell_container__X3hn1","pill":"registered-model-cell_pill__QVwig","searchButton":"registered-model-cell_searchButton__hpjg+"};